// extracted by mini-css-extract-plugin
module.exports = {"bold-label":"bold-label__bold-label___3rv-c"};